var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chaos"},[_c('div',{staticClass:"words",class:{ 'darken': _vm.darken }},_vm._l((_vm.shuffledWords),function(word){return _c('div',{staticClass:"word",style:(_vm.randomStyle())},[_vm._v(_vm._s(word))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }